import gql from 'graphql-tag';
import { graphMutation, graphQuery } from '@services/commService';
import { ACTIVITY_TYPES } from '../constants';

export const getActivityProductions = async (exerciseId) => {
  const query = gql`
    query{
      activityProductions(context:{ACTIVITY_EXERCISE:"${exerciseId}" }){
        id
        startTS
        textStimuli{
          words {
            syllables{
              text
            }
          }
        }
        stimuliDisplayed{
          wordIndex
          syllableIndex
        }
        dspSignal
        productionLength
        activityCreated{
          at
        }
        productionErrors{
          type
          exists
          displayed
        }
        stimuliDisplayed {
          id
          wordIndex
          syllableIndex
        }
      }  
    }`;
  const res = await graphQuery(query);
  return res;
};

export const createFeedback = async ({ type, id }, text, dismiss, isMeaningful) => {
  const mutation = gql`mutation{
    post:createFeedback(
      activity:{
        type:${type},
        id:"${id}",
      }
      isDismiss:${Boolean(dismiss)},
      isMeaningful:${Boolean(isMeaningful)},
      text:"""${text}"""
      ) {
      id
      createdAt
      payload
      publisherUser{
        id
        avatar
        fullName
      }
    }
  }`;
  const res = await graphMutation(mutation);

  return res;
};

export const editFeedback = async (id, text, isMeaningful) => {
  const mutation = gql`mutation{
    post:editPost (
      id:"${id}"
      isMeaningful:${Boolean(isMeaningful)}
      text:"""${text}"""
      ) {
      id
      createdAt
      payload
      publisherUser{
        id
        avatar
        fullName
      }
    }
  }`;
  const res = await graphMutation(mutation);

  return res;
};

export const deleteFeedback = async (id) => {
  const mutation = gql`mutation{
    response:deletePost (
      id:"${id}"
      ) {
      success
      id
    }
  }`;
  const res = await graphMutation(mutation);

  return res;
};

export const visit = async (type, id) => {
  const mutation = gql`
  mutation{
    visit(type:${type},id:"${id}"){
      type
      id
      visitorId
    }
  }`;
  const res = await graphMutation(mutation);
  return res;
};

export const visitAll = async (type, ids) => Promise.all(ids.map((id) => visit(type, id)));

export const getActivityGQLNode = (type) => {
  const gqlNodes = {
    [ACTIVITY_TYPES.ACTIVITY_PRACTICE]: 'activityPractices',
    [ACTIVITY_TYPES.ACTIVITY_POLL]: 'activityPolls',
  };
  if (!gqlNodes[type]) throw new Error(`missing type ${type}`);
  return gqlNodes[type];
};

export const getUserActivityData = async (type, id) => {
  const gqlNode = getActivityGQLNode(type);
  const isPracticeActivity = type === ACTIVITY_TYPES.ACTIVITY_PRACTICE;
  const isPollActivity = type === ACTIVITY_TYPES.ACTIVITY_POLL;
  const practiceFields = isPracticeActivity
    ? `
        EntityExercises{
          id
          name
        }
        Exercises{
          id
          activityCreated{
            at
          }
          activityMediaAudio {
            publicUrls
          }
          activityMediaVideo {
            publicUrls
            mediaDuration
          }
          summary{
            errorsDistribution
            achievedMasteryLevel
            insights {
              type
              insights {
                severity
                error
              }
            }
            hasPassed
          }
          entity{
            id
            name
            monitor {
              pattern
              errors
            }
          }
        }
        summary{
          achievedMasteryLevel
          insights {
            type
            insights {
              severity
              error
            }
          }
          hasPassed
          passedAt
        }
      `
    : '';
  const pollFields = isPollActivity
    ? `
        entity {
          id
          name
          description
          surveySchema
        }
        surveyResponse
        answers {
          id
          payload
        }
        timeSpent
        pollSkipped
      `
    : '';
  const query = gql`
    query{
      activities:${gqlNode}(id:"${id}"){
        ParentSkill {
          name
        }
        activityCreated{
          at
        }
        id
        type
        userId
        entity{
          name
        }
        Threads {
          Posts {
            id
            createdAt
            payload
            publisherUser{
              id
              avatar
              fullName
            }
          }
        }
        user{
          fullName
          avatar
          email
          birthdate
        }
        ${practiceFields}
        ${pollFields}
      }
    }`;
  const res = await graphQuery(query);
  return res;
};
